module.exports = "pegasus_template/assets/blocks/header-8-tech.png";